import { useEffect, useState } from "react";
import Input from "components/ui/Input";
import Modal from "components/ui/modals";

const emptyCashCustomer = {
  cname: "",
  add1: "",
  add2: "",
  city: "",
  state: "",
  pin: "",
  contactno: "",
};

export default function CashCustomerModal({ open, onClose, value, onSave }) {
  const [formData, setFormData] = useState(emptyCashCustomer);

  useEffect(() => {
    if (open) {
      setFormData({ ...emptyCashCustomer, ...value });
    }
  }, [open, value]);

  const handleChange = (event) => {
    const { name, value: fieldValue } = event.target;
    setFormData((current) => ({ ...current, [name]: fieldValue }));
  };

  const handleSave = (event) => {
    event.preventDefault();
    onSave({
      ...formData,
      cname: formData.cname.trim(),
      add1: formData.add1.trim(),
      add2: formData.add2.trim(),
      city: formData.city.trim(),
      state: formData.state.trim(),
      contactno: formData.contactno.trim(),
      pin: formData.pin ? Number(formData.pin) : undefined,
    });
    onClose();
  };

  return (
    <Modal
      open={open}
      setOpen={(isOpen) => !isOpen && onClose()}
      maxWidth="2xl"
      header={<h3 className="text-base font-semibold leading-6 text-gray-900">Cash Customer Details</h3>}
      footer={
        <div className="flex justify-end gap-x-3">
          <button type="button" className="text-sm font-semibold rounded-md px-3 py-2 hover:bg-gray-100 text-gray-900" onClick={onClose}>
            Cancel
          </button>
          <button type="submit" form="cash-customer-form" className="rounded-md bg-gray-700 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-500">
            Save Details
          </button>
        </div>
      }
    >
      <form id="cash-customer-form" onSubmit={handleSave} className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <Input label="Customer Name" name="cname" value={formData.cname} onChange={handleChange} maxLength={30} required />
        <Input label="Contact No." name="contactno" value={formData.contactno} onChange={handleChange} maxLength={15} />
        <Input label="Address Line 1" name="add1" value={formData.add1} onChange={handleChange} maxLength={30} />
        <Input label="Address Line 2" name="add2" value={formData.add2} onChange={handleChange} maxLength={30} />
        <Input label="City" name="city" value={formData.city} onChange={handleChange} maxLength={15} />
        <Input label="State" name="state" value={formData.state} onChange={handleChange} maxLength={15} />
        <Input label="PIN" type="number" name="pin" value={formData.pin} onChange={handleChange} min={0} />
      </form>
    </Modal>
  );
}
